import axios from "axios";
import { kaya } from "../../api";

const apiUrl = kaya;

export function loadKaya(pageLimit, page, search, boundary, zone) {
  const b = boundary ? `&boundary=${boundary}` : "";
  const z = zone ? `&zone=${zone}` : "";
  return axios.get(
    `${apiUrl}/kaya/filter?limit=${pageLimit}&offset=${page}&search=${search || ""}${b}${z}`
  );
}

export function loadKayaMember(pageLimit, page, search, boundaryId, zone) {
  const b = boundaryId ? `&boundary=${boundaryId}` : "";
  const z = zone ? `&zone=${zone}` : "";
  return axios.get(
    `${apiUrl}/kaya/member/filter?limit=${pageLimit}&offset=${page}&search=${search || ""}${b}${z}`
  );
}

export function loadKayaMemberDead(pageLimit, page, search, boundaryId) {
  const b = boundaryId ? `&boundary_id=${boundaryId}` : "";
  return axios.get(
    `${apiUrl}/kaya/member/dead/filter?limit=${pageLimit}&offset=${page}&search=${search}${b}`
  );
}

export function loadKayaDetails(id) {
  return axios.get(`${apiUrl}/kaya/details/${id}`);
}

export function loadBuildingKaya(pageLimit, page, search) {
  return axios.get(
    `${apiUrl}/kaya/list?limit=${pageLimit}&offset=${page}&search=${search}`
  );
}

export function loadKayaData(pageLimit, page, phone, search) {
  return axios.get(
    `${apiUrl}/kaya/data?limit=${pageLimit}&offset=${page}&head_phone_number=${phone}&search=${search}`
  );
}

export function loadKayaCount() {
  return axios.get(`${apiUrl}/kaya/count`);
}

export function loadKayaMemberCount() {
  return axios.get(`${apiUrl}/kaya/member/count`);
}

export function loadKayaMemberChart() {
  return axios.get(`${apiUrl}/kaya/member/chart`);
}

export function loadKayaMemberEducation() {
  return axios.get(`${apiUrl}/kaya/member/report/education`);
}

export function addKaya(data) {
  return axios.post(`${apiUrl}/kaya`, data);
}

export function addKayaBuilding(data) {
  return axios.post(`${apiUrl}/kaya/building`, data);
}

export function addMember(data) {
  return axios.post(`${apiUrl}/kaya/member`, data);
}

export function addKayaMember(data) {
  return axios.post(`${apiUrl}/kaya/member/kaya`, data);
}

export function loadKayaUpdate(id) {
  return axios.get(`${apiUrl}/kaya/update/${id}`);
}

export function updateKaya(id, data) {
  return axios.put(`${apiUrl}/kaya/update/${id}`, data);
}

export function updateKayaBuilding(id, data) {
  return axios.put(`${apiUrl}/kaya/building/transfer/${id}`, data);
}

export function loadMemberUpdate(id) {
  return axios.get(`${apiUrl}/kaya/member/update/${id}`);
}

export function updateMember(id, data) {
  return axios.put(`${apiUrl}/kaya/member/update/${id}`, data);
}

export function updateDeadMember(id, data) {
  return axios.put(`${apiUrl}/kaya/member/dead/${id}`, data);
}

export function memberChangeKaya(id, data) {
  return axios.post(`${apiUrl}/kaya/person/post/${id}`, data);
}

export function removeMember(id, data) {
  return axios.put(`${apiUrl}/kaya/person/close/${id}`, data);
}

export function generateRegistrationNumber(kayaId, residentialStatusId) {
  return axios.get(`${apiUrl}/kaya/member/generate-reg-no?kaya_id=${kayaId}&residential_status_id=${residentialStatusId}`);
}
